import { differenceInCalendarDays, parseISO } from 'date-fns'

/* Whole calendar days since the deadline day, ignoring the time of day:
   deadline 2025-10-10, today 2025-10-09 => -1
   deadline 2025-10-10, today 2025-10-10 => 0 (still on time)
   deadline 2025-10-10, today 2025-10-11 => 1
   `reportDeadline` is a date, so it is parsed as a local date: `new Date('2025-10-10')` is UTC midnight and would count
   the deadline day itself as overdue */
export const getDaysPastDeadline = (reportDeadline: string): number =>
  differenceInCalendarDays(new Date(), parseISO(reportDeadline))
